<template>
    <div class="tomList">
        <div class="clearfix fixed">
            <van-nav-bar
                class="restclass"
                title="待保养"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>
        <div class="clientList">
            <row class="search">
                <van-col span="18"><search v-model="value" placeholder="请输入搜索关键词" class="search" /></van-col>
                <van-col span="2">
                    <van-button type="primary" size="normal" round style="font-size:13px;margin-top:8px;"
                        @click="search">查&nbsp;询</van-button>
                </van-col>
                <van-col span="2" style="float:right; margin:5px 0 0 15px;">
                    <van-icon name="scan" size="30" round title="扫一扫"
                        @click="scan" />
                </van-col>
            </row>
            <row>
                <van-col span="4"><van-button type="primary" size="normal" round
                    @click="getListAll">全部</van-button></van-col>
                <van-col span="9">
                    <dropdown-menu active-color="#ee0a24">
                        <dropdown-item v-model="value2" :options="option2" />
                    </dropdown-menu>
                </van-col>
                <van-col span="9">
                    <dropdown-menu active-color="#ee0a24">
                        <dropdown-item v-model="value1" :options="option1" @change="categoryChange" />
                    </dropdown-menu>
                </van-col>

            </row>
            <row><van-col span="24">&nbsp;</van-col></row>
            <List
                v-model="fansLoading"
                :finished="fansFinished"
                finished-text="已加载全部"
                @load="loadMore">
                <div
                    v-for="(item,index) in list"
                    :key="item.Id"
                    class="list clearfix">
                    <div class="clearfix">
                        <row>
                            <van-col span="1">{{ index+1 }}</van-col>
                            <van-col span="20">
                                <p>
                                    <span class="info-span">{{ item.vehicleCode }}</span>
                                    <span class="info-span">{{ item.barCode }}</span>
                                </p>
                                <p>
                                    <span class="info-span">{{ item.owner }}</span>
                                    <span class="info-span">{{ `${item.category} - ${item.model}` }}</span>
                                </p>
                            </van-col>
                            <van-col v-if="$_has('maintain:maintenancelist:edit')" span="3"><van-button type="primary" round @click="dispatch(item.id)">关闭</van-button></van-col>
                        </row>
                    </div>
                </div>
            </List>
            <p
                v-if="list.length === 0"
                class="noList">暂无数据</p>
        </div>
        <bottom />
    </div>
</template>

<script>
import { getToMaintainList, closeToMaintain } from '@/api/maintain'
import { getcategory, getVehiclemodelList } from '@/api/basics'
import { Icon, List, Button, Col, Row, Search, DropdownMenu, DropdownItem } from 'vant'
import bottom from '@/components/bottom'
export default {
    name: 'ToMaintainList',
    components: {
        bottom,
        Icon, List, [Button.name]: Button, [Col.name]: Col, Row, Search, DropdownMenu, DropdownItem
    },
    data() {
        return {
            fansLoading: false,
            fansFinished: false,
            parameter: {
                SnOrTerminalId: '',
                pageIndex: 1, // 当前页
                pageSize: 10, // 每页多少条
                category: '', // 车辆类别
                model: '', // 车辆型号
                searchKey: ''

            },
            list: [],
            value: '',
            value1: 0,
            value2: '按型号',
            option1: [],
            option2: [],
            paraModel: {
                vehicleTypeIds: null,
                beginDate: null,
                endDate: null,
                pageIndex: 0,
                pageSize: 0
            },
            totalCount: 0
        }
    },
    created() {
        this.queryList()
    },
    mounted() {
        window['scanit'] = data => {
            this.scanit(data)
        }
        this.getCategoryList()
        this.getModelList()
    },
    methods: {
        loadMore() {
            if (!this.fansFinished) {
                this.parameter.pageIndex++
                this.fansLoading = true
                getToMaintainList(this.parameter).then(response => {
                    this.list.push.apply(this.list, response.data.pagerData)
                    // this.list = this.list.concat(response.data)
                    this.totalCount = response.data.totalCount
                }).finally(this.afterLoad)
            }
            // this.fansLoading = true
            // if (this.refreshing) {
            //     this.parameter.pageIndex = 1
            //     this.list = []
            // }
            // getToMaintainList(this.parameter).then(res => {
            //      if (res.code == 200) {
            //         this.parameter.pageIndex === 1 ? this.list = res.data.pagerData : this.list = this.list.concat(res.data.pagerData)
            //         // 判读是否加载到最后一页
            //         this.list.length >= res.data.totalCount ? this.fansFinished = true : this.parameter.pageIndex++
            //         // 请求完毕后隐藏正在 加载样式
            //         this.fansLoading = false
            //         this.refreshing = false
            //     }
            //     // this.list = res.data.pagerData
            // })
        },
        afterLoad() {
            this.fansLoading = false
            this.fansFinished = this.list.length == this.totalCount
        },
        search() {
            this.parameter.pageIndex = 1
            this.queryList()
        },
        queryList() {
            this.fansLoading = true
            this.list = []
            this.parameter.category = ''
            this.option1.forEach(item => {
                if (item.value == this.value1) {
                    this.parameter.category = item.text
                }
            })
            this.parameter.model = this.value2
            console.log(11111, this.parameter.category, this.parameter.model)
            if (this.parameter.model == '按型号') {
                this.parameter.model = ''
            }
            if (this.parameter.category == '按类型') {
                this.parameter.category = ''
            }
            this.parameter.searchKey = this.value
            getToMaintainList(this.parameter).then(response => {
                this.list = response.data.pagerData
                this.totalCount = response.totalCount
            }).finally(this.afterLoad)
        },
        getListAll() {
            this.value1 = 0
            this.value2 = '按型号'
            this.value = ''
            this.parameter.SnOrTerminalId = ''
            this.parameter.pageIndex = 1 // 当前页
            this.parameter.pageSize = 10 // 每页多少条
            this.parameter.category = '' // 车辆类别
            this.parameter.model = '' // 车辆型号
            this.parameter.barCode = ''
            this.queryList()
        },
        getCategoryList() {
            this.option1 = [{ text: '按类型', value: 0 }]
            getcategory().then((res) => {
                if (res.code == 200) {
                    res.data.forEach(item => {
                        this.option1.push({
                            text: item.content,
                            value: item.id
                        })
                    })
                }
            })
        },
        getModelList() {
            this.option2 = [{ text: '按型号', value: '按型号' }]
            getVehiclemodelList(this.paraModel).then((res) => {
                if (res.code == 200) {
                    res.data.pagerData.forEach(item => {
                        this.option2.push({
                            text: item.name,
                            value: item.name
                        })
                    })
                }
            })
        },
        categoryChange(data) {
            // this.paraModel.vehicleTypeIds=[this.value1]
            // this.getModelList()
        },
        // 返回
        getBack() {
            this.$router.push({ path: '/' })
        },
        // 扫一扫
        scan() {
            window.test.ToScan()
        },
        scanit(val) {
            console.log(this.payload)
            // this.payload.barCode = val
            this.parameter.pageIndex = 1
            this.parameter.barCode = val
            getToMaintainList(this.parameter).then(res => {
                this.list = res.data.pagerData
            })
        },
        dispatch(mtId) {
            this.$dialog.confirm({
                title: '提示',
                message: '是否关闭待保养提示',
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                console.log('点击了确认按钮')
                closeToMaintain(mtId).then(res => {
                    console.log(res)
                    if (res.isSuccess) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        // this.parameter.pageIndex = 1 // 当前页
                        // this.parameter.pageSize = 10 // 每页多少条
                        this.parameter.pageIndex = 1
                        this.queryList()
                    }
                })
            }).catch(() => {
                console.log('点击了取消按钮')
            })
        }
    }
}
</script>

<style lang='scss'>
.tomList{
  width: 100%;
  .logout{
    margin-top: -20px;
    color: blue;
  }
  .clientList{
    margin-bottom: 100px;
    padding: 0px 40px;
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:10px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }

}

</style>
<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.noList{
  text-align: center;
  margin-top: 50%;
  font-size: 26px;
  color: #ccc;
}
.info-span{
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:45%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.info-span-red{
    padding:0px 8px;
    color:#f00;
}
.van-dialog{
  width: 70%;
  height: 15%;
  .van-dialog__content{
    height: 65%;
    padding-top: 5%;
    text-align: center;
    .van-dialog__message{
      text-align: center;
      font-size: 26px;
    }
  }
  .van-dialog__footer--buttons{
    height: 35%;
    .van-button{
      width: 50%;
      height: 100%;
      .van-button__text{
        font-size: 26px;
      }
    }
  }
}
</style>
